/*
 * @Author: WH-Chen cwh2024@163.com
 * @Date: 2025-06-14 14:22:51
 * @LastEditors: WH-Chen cwh2024@163.com
 * @LastEditTime: 2025-06-14 14:42:41
 * @FilePath: \school\src\store\modules\menu.ts
 * @Description:
 *
 * Copyright (c) 2025 by ${WH-Chen}, All Rights Reserved.
 */
import { defineStore } from 'pinia'
import { store } from '../index'
import { useRouter } from 'vue-router'
import { computed, ref, watch } from 'vue'
import type { Component } from 'vue'
import { Location, Menu as IconMenu, Document, Setting } from '@element-plus/icons-vue'

export interface MenuItem {
  index: string
  icon?: Component
  label: string
  children?: any
  disabled?: boolean
}

export interface MenuControlState {
  currentPage: string
}

export const useMenuStore = defineStore(
  'menu',
  () => {
    const { currentRoute } = useRouter()

    // 当前用于高亮的菜单路径
    const currentPage = ref('')

    // 当前父级路由
    const parentRoute = ref<Record<string, any>>({})

    // 左侧菜单数据
    const currentMenuItem = ref<MenuItem[]>([
      {
        index: '/basicData/courseManagement',
        icon: IconMenu,
        label: '课程管理'
      },
      {
        index: '/teacher',
        icon: Location,
        label: '老师',
        children: [
          { index: '/basicData/teacherManage', label: '老师管理' },
          { index: '/basicData/teacherAttendance', label: '老师考勤' }
        ]
      },
      {
        index: '/basicData/apply',
        icon: IconMenu,
        label: '申请'
      },
      {
        index: '/basicData/material',
        icon: Document,
        label: '材料信息'
      },
      {
        index: '/basicData/school',
        icon: Setting,
        label: '学校'
      },
      {
        index: '/basicData/permissionManagement',
        icon: Setting,
        label: '权限管理'
      }
    ])

    const syncMenuState = () => {
      const route = currentRoute.value

      // 关键：优先读 activeMenu，没有才回退到 path
      currentPage.value = (route.meta?.activeMenu as string) || route.path

      parentRoute.value = route.matched[route.matched.length - 2] || {}
    }

    const setPage = (page: string) => {
      currentPage.value = page
    }

    const isCurrentPage = (page: string) => {
      if (!page) return false
      return currentPage.value.includes(page)
    }

    const setCurrentMenuItem = (menuItems: Array<MenuItem>) => {
      currentMenuItem.value = menuItems
    }

    const getCurrentMenuItem = computed(() => {
      return currentMenuItem.value
    })

    watch(
      currentRoute,
      () => {
        syncMenuState()
      },
      {
        immediate: true,
        deep: true
      }
    )

    return {
      currentPage,
      parentRoute,
      currentMenuItem,
      getCurrentMenuItem,
      setCurrentMenuItem,
      setPage,
      isCurrentPage
    }
  },
  {
    persist: {
      key: 'menu',
      storage: window.localStorage
    }
  }
)

export const useMenuStoreWithOut = () => {
  return useMenuStore(store)
}
